import React from 'react';
import people from '@/imgs/AnalysisSpec/people.png';
import talk from '@/imgs/AnalysisSpec/talk.png';
interface FundInfo {
  label: string;
  value: string;
}

interface AnalysisSpecProps {
  fundName?: string;
  fundCode?: string;
  fundInfo?: any;
}

const AnalysisSpec: React.FC<AnalysisSpecProps> = ({
  fundName = '华夏复兴混合A',
  fundCode = '000031',
  fundInfo = {}
}) => {
  return (
    <div className="mb-3 flex flex-col gap-0">
      {/* 头部区域 */}
      <div className="relative h-36 overflow-hidden rounded-t-lg bg-gradient-to-br from-purple-50 to-indigo-50">
        {/* 背景装饰图片 */}
        <div className="absolute inset-0 flex">
          <div className="h-36 w-24 rounded-l-lg bg-gradient-to-br from-blue-100 to-purple-100"></div>
          <div className="flex-1 bg-gradient-to-r from-purple-100 to-indigo-100"></div>
        </div>

        {/* 内容 */}
        <div className="relative z-10 mt-[10px] flex h-full items-center px-6">
          <div className="h-[148px] w-[100px]">
            <img src={people} className="h-full w-full object-cover" alt="分析" />
          </div>
          <div
            className="h-[124px] w-[238px] bg-cover bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${talk})` }}
          >
            <h2 className="mt-[18px] text-sm leading-relaxed text-gray-900">
              正在对{fundName}
              <br />
              （代码：{fundCode}）进行深度解读
            </h2>
          </div>
        </div>
      </div>

      {/* 基金信息卡片 */}
      <div className="relative z-[111] mt-[-20px] rounded-b-lg border border-gray-200 bg-gradient-to-r from-[#E7EAFF] to-[#E7E5FF] p-3">
        <div className="grid grid-cols-2 gap-6">
          {/* 第一列 */}
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-xs text-gray-900">基金类型</span>
              <span className="text-xs font-semibold text-gray-900">
                {fundInfo && fundInfo.基金类型}
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-xs text-gray-900">跟踪指数</span>
              <span className="text-xs font-semibold text-gray-900">
                {fundInfo && fundInfo.跟踪指数}
              </span>
            </div>
          </div>

          {/* 第二列 */}
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-xs text-gray-900">成立时间</span>
              <span className="text-xs font-semibold text-gray-900">
                {fundInfo && fundInfo.成立时间}
              </span>
            </div>
            {/* <div className="flex items-center justify-between">
              <span className="text-xs text-gray-900">管理费</span>
              <span className="text-xs font-semibold text-gray-900">
                {fundInfo && fundInfo.管理费}
              </span>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalysisSpec;
